import { FC } from 'react';
import {
  HStack,
  Icon,
  IconButton,
  Text,
  Tooltip,
  useBreakpointValue,
  VStack,
} from '@wegroup/design-system';
import { AnvaQuote } from '@flows/src/types/anva';
import { truncate } from 'lodash';
import { toEuro } from '@sales-conversation/src/utils/stringUtils';
import { useTranslation } from 'react-i18next';
import { isMaatwerkQuote } from '@flows/src/utils/basketCalculations';

interface Props {
  data: AnvaQuote;
  onRemove: () => void;
}

const AnvaProductCartWidgetItem: FC<Props> = ({ data, onRemove }) => {
  const { t } = useTranslation();
  const truncateValue = useBreakpointValue({ base: 10, laptopL: 17 }) || 18;

  return (
    <HStack h="50px" borderTop="1px" p="3" borderColor="gray.50" spacing="2">
      <IconButton
        aria-label="remove"
        icon={<Icon name="GeneralActionsThrash" boxSize="5" />}
        variant="dangerSecondary"
        size="sm"
        onClick={onRemove}
      />
      <VStack align="stretch" spacing="0" flexGrow={1}>
        <Text textStyle="smallBody" color="gray.300" isTruncated>
          {truncate(data.insurance_company.name, { length: truncateValue })}
        </Text>
        <Tooltip
          label={data.name}
          shouldWrapChildren
          placement="right"
          isDisabled={data.name.length < truncateValue}
        >
          <Text textStyle="normalBodyMedium">
            {truncate(data.name, { length: truncateValue })}
          </Text>
        </Tooltip>
      </VStack>
      <Text color="gray.500">
        {isMaatwerkQuote(data) ? t('MAATWERK') : toEuro(data?.total_premium)}
      </Text>
    </HStack>
  );
};

export default AnvaProductCartWidgetItem;
